import { t } from "i18next";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Alert, Box, Button, Typography } from "@mui/material";

interface FeedbackSuccessStateProps {
  hasImageFailures?: boolean;
  onNewFeedback: () => void;
}

const FeedbackSuccessState = ({
  hasImageFailures,
  onNewFeedback
}: FeedbackSuccessStateProps) => {
  return (
    <Box sx={{ textAlign: "center", py: 4 }}>
      <CheckCircleIcon
        sx={(muiTheme) => ({
          fontSize: 64,
          color: muiTheme.palette.semantic.success.main,
          mb: 2
        })}
      />

      <Typography
        variant="h3"
        sx={(muiTheme) => ({
          mb: 2,
          color: muiTheme.palette.semantic.success.main
        })}
      >
        {t("feedbackForm.successTitle")}
      </Typography>

      <Typography variant="body1" sx={{ mb: 2 }}>
        {t("feedbackForm.successMessage")}
      </Typography>

      {hasImageFailures && (
        <Alert severity="warning" sx={{ mb: 3 }}>
          {t("feedbackForm.error.imageUploadPartial")}
        </Alert>
      )}

      <Button variant="outlined" onClick={onNewFeedback} sx={{ mt: 2 }}>
        {t("feedbackForm.sendNewFeedback")}
      </Button>
    </Box>
  );
};

export default FeedbackSuccessState;
